// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af21d7df","453":"bfdd2f9f","553":"7aea0c50","977":"3748e6bb"}[chunkId] + ".chunk.js";
};